<template>
  <div>
    <h2 class="mb-6 text-uppercase text-center">
      Medium Business
    </h2>
    <h4 class="mb-2">
      4 SubUsers | 200 Credits | 20GB storage limit
    </h4>
    <p>Small business features plus:</p>
    <ul class="mb-6">
      <li>Generate documents on behalf of 2 group entities</li>
      <li>Multiple authorised signatories</li>
      <li>Consolidated Dashboard views by User</li>
      <li>My Templates Section (automate your own documents)</li>
    </ul>
    <p>
      Scaling companies who need greater diligence in systems management and
      well organised registers.
    </p>
  </div>
</template>
<script>
export default {
  name: 'MediumBusinessPlanDescription'
}
</script>
<style lang="sss" scoped></style>
